/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './registerPush.defs.js'
export { main as default } from './registerPush.defs.js'
